// SSO Protocol Enum
export enum SSOProtocol {
  OIDC = 'oidc',
  SAML2 = 'saml2'
}

// Base SSO Configuration
export interface BaseSSOConfig {
  protocol: SSOProtocol
  enabled: boolean
  displayName: string
}

// OIDC SSO Configuration
export interface OIDCSSOConfig extends BaseSSOConfig {
  protocol: SSOProtocol.OIDC
  authority: string
  clientId: string
  redirectUri: string
  scopes: string[]
  responseType: string
}

// SAML2 SSO Configuration
export interface SAML2SSOConfig extends BaseSSOConfig {
  protocol: SSOProtocol.SAML2
  idpUrl: string
  entityId: string
  acsUrl: string // Assertion Consumer Service URL
  certificate?: string
}

// Union type for SSO Configuration
export type SSOConfig = OIDCSSOConfig | SAML2SSOConfig

// Domain SSO Configuration
export interface DomainSSOConfiguration {
  domain: string
  ssoConfig: SSOConfig | null
  defaultAuthMethod: 'sso' | 'password'
}

// Legacy SSO Configuration Interface (for backward compatibility)
export interface LegacySSOConfig {
  authority: string
  clientId: string
  redirectUri: string
  scopes: string[]
  responseType: string
}





